var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProfileOn = function SvgProfileOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 27 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4D55",
    stroke: "#4A4D55",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.36 11.802a3.901 3.901 0 1 0 0-7.802 3.901 3.901 0 0 0 0 7.802M21.719 21.834v-2.881c0-2.414-1.995-4.364-4.459-4.364H9.458C6.995 14.589 5 16.545 5 18.953v2.88z"
  })));
};
export default SvgProfileOn;